
// npm
import React from 'react'


const MachineContext = React.createContext();


export {MachineContext}